export default "__VITE_ASSET__Df9O0xGN__"